import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input } from '@angular/core';
import { ComponentBase } from '../../../base-classes/componet-base';

@Component({
    selector: 'app-svg-icon',
    templateUrl: './svg-icon.component.html',
    styleUrls: ['./svg-icon.component.scss']
})
export class SvgIconComponent extends ComponentBase implements OnInit {

    @Input() icon_name: string;
    public svg: string;
    constructor(private http: HttpClient) {
        super();
    }

    ngOnInit() {
        if (this.icon_name) {
            this.http.get('assets/icons/' + this.icon_name, { responseType: 'text' })
                .subscribe((res) => {
                    this.svg = res;
                });
        }
    }

}
